import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';
import { GRID } from '../components/constants';
import { useSnippetsContext } from '../context';

export const LOADING_ROW_TEST_ID = 'snippets-loading-row';
type StyledRowProps = {
  color?: string;
};

const StyledRow = styled.div<StyledRowProps>`
  align-items: center;
  background: ${({ color }) => color};
  column-gap: ${spacing.base};
  display: grid;
  grid-template-columns: ${GRID};
  height: ${spacing.x6};
  padding: ${spacing.base} 40px;
`;

const LOADING_ROW_CELLS = [180, 120, 132, 107, 107].map((width, i) => (
  <Skeleton key={i} height={14} width={width} />
));

type LoadingRowProps = {
  color?: string;
};

const LoadingRow = ({ color }: LoadingRowProps) => {
  return (
    <StyledRow data-test={LOADING_ROW_TEST_ID} color={color}>
      {LOADING_ROW_CELLS}
    </StyledRow>
  );
};

export const useGetLoadingTableData = () => {
  const {
    pagination: { limit },
  } = useSnippetsContext();

  return [...Array(limit)].map((_, id) => ({
    id,
    row: <LoadingRow />,
  }));
};
